import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

/** ## Query client. */
export const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutationCache: new MutationCache(),
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
    mutations: {},
  },
});

window.__TANSTACK_QUERY_CLIENT__ = queryClient;

export const data = async <T>(response: Response): Promise<T> => {
  const text = await response.text();
  if (!text) {
    return undefined as unknown as T;
  }
  return JSON.parse(text) as T;
};
